import React, { useState }from 'react';
import useSession from '../../useSession';
import Box from '@mui/material/Box';
//import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';
import './AgreeTerms.css';
import { SaveTermsRead } from '../Helpers/Helpers';

export default function AgreeTerms() {

    const { sessionItem } = useSession(); 
    const [sbopen, setSbOpen] = useState(false);
    const [opMessage, setOpMessage] = useState("");      

    function ValidateConfirm() { 
        SaveTermsRead(sessionItem.film.filmObjId, 43200);
        // redirect to the home page            
        window.location.href = '/';
    }

    function handleSnackBarClose() {       
        setOpMessage("");
        setSbOpen(false);       
    }

    const sbaction = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleSnackBarClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );    

    return (
        <Box sx={{ minWidth: 800, bgcolor: '#F0F0F0', p: 1}}>
            {/*<h2>Publicity contacts for the film: {sessionItem.film.engTitle}</h2>  */}          
            <Box>
                <article>
                    <h2>CONFIRM FILM PUBLICISTS</h2>
                    <p>
                        Upon clicking "Confirm Information" you will be taken to a page with the
                        publicity contact information initially submitted at the film invitation stage.
                    </p>                               
                </article>
                <article>
                    <h2>WHY SHOULD YOU CONFIRM YOUR PUBLICISTS?</h2>
                    <ul>
                        <li>
                            We need a contact to provide to the media who are interested in covering your film.
                            The publicist contact you supply here for each territory will be shared with the
                            TIFF accredited media list. This gives accredited media the correct contacts for your film.
                        </li>
                        <li>
                            We use this information to know what publicists and publicist companies
                            are representing films at the Festival and will need to register
                            for Publicist Passes.
                        </li>
                        <li>
                            If you don't submit this form or we don't have a publicist contact
                            for your film, we will have to send interested media to the Press
                            Office Contact you entered on your Film Registration Form instead.
                        </li>
                    </ul> 
                    <p>
                        If you don't have a publicist for your film, please
                        email <a class="lightblue" href="mailto:publicistregistration@tiff.net">publicistregistration@tiff.net</a> to let
                        the team know who the contact for media interest will be.
                    </p>
                    <p>
                        Please review and confirm your film's list of publicist contacts on this form
                        by <span className="boldtext">Monday, August 3, 2026 at 8PM EDT/5PM PDT</span>.
                        Please note: The sooner this information is confirmed, the sooner we will
                        reach out regarding registration for Publicist passes.
                    </p>
                    <p>
                        This form may be updated and saved several times before submitting.
                         <span className="boldtext"> However, once it is submitted it is considered final
                            and you cannot submit changes through the form.</span> At that point, you
                        will need to email publicist contact changes to <a class="lightblue" href="mailto:publicistregistration@tiff.net">publicistregistration@tiff.net</a>.
                    </p>
                    <p>
                        To submit the form, your form must include:
                        <ul>
                            <li>
                                A Press Office Contact (the main contact for TIFF Communications
                                to reach out to regarding media, press, PR-related matters, etc.)
                            </li>
                            <li>
                                At least one Publicist role (Canadian Publicist, US Publicist,
                                International Publicist)
                            </li>
                            <li>
                                One of the Publicist roles must be tagged as the Primary Contact
                                (aka Primary Publicist)
                            </li>
                        </ul>
                        <a target="_blank" href="/pdf/formhelp.pdf">Click here for a step-by-step guide to filling out and submitting this form.</a>
                    </p>
                    <p>
                        Please note: You must mark one of the publicists as the Primary publicist. You won't
                        be able to submit your completed form without doing this.
                    </p>
                </article>               
                <article>                   
                    <div>                        
                        <div>
                            <Button variant="contained" sx={{ marginBottom: 1}} name="addrolebt" onClick={ValidateConfirm} >
                                Confirm Information
                            </Button>
                        </div>
                        {/*<div>*/}
                        {/*    It is recommended to use the same browser when completing the Publicist Assignment Form.*/}
                        {/*</div>*/}
                    </div>
                </article> 
                <Snackbar
                    open={sbopen}
                    autoHideDuration={3000}
                    onClose={handleSnackBarClose}
                    message={opMessage}
                    action={sbaction}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                />
            </Box>
        </Box>

    );
}